import React from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import {CopyToClipboard} from 'react-copy-to-clipboard';

const ErrorDialog = (props) => {
    return (
        <Modal show={props.show} onHide={props.handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>{props.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>{props.body}</Modal.Body>
            <Modal.Footer>
                <Button className="mr-auto" variant="secondary" onClick={props.handleClose}>
                    Close
            </Button>
                <CopyToClipboard text={props.getJsonState()}>
                    <Button className="copy-state-button" variant="primary" onClick={props.handleCopyState}>
                        Copy State to Clipboard
                    </Button>
                </CopyToClipboard>
            </Modal.Footer>
        </Modal>

    );
}

export default ErrorDialog;